import { mDom, forcePageReflow } from '@core/js/utils/renderUtils';

import { shouldActivateParsley, checkForm } from '@core/js/utils/errorHandling';

import {
    changeQuantity,
    changeSizeType,
    changeSize,
    saveFormValidation,
    selectColorSwatch,
    backInStockView
} from '../actions/productActions';

import template from 'controls/product-controls-faceout.j2';

import { generate } from '@core/js/utils/componentUtils';
import { onStateChange } from '../utils/productComponentUtils';

import { pushModalTransition } from '@core/js/actions/modalActions';

import { init as sizeGuideInit } from '../components/productSizeGuideComponent';
import { init as quickshipInfoModalInit } from '@core/js/components/quickshipInfoModalComponent';
import { isIosDevice } from '@core/js/utils/browserUtils';
import { scrollToElement } from '@core/js/utils/scrollUtils';
import { getSizeGuideForTypeCodeSaga } from '@product/js/sagas/sizeGuideSagas';

/**
 * Attach component events to DOM
 * @param {object} store The store
 * @returns {undefined}
 */
function attachEvents(store) {
    const _this = this;

    // Watch for color selection change

    $(document).on(this.scopedEvent('touchend click'), this.scopedSelector('.js-swatch-link-product'), (e) => {
        e.preventDefault();
        const path = e.currentTarget.href;
        const newColorCode = path.split('?color=')[1];

        // TODO: update query param color code when color changes for hard refresh
        store.dispatch(selectColorSwatch(newColorCode, e, _this));
    });

    // Watch for size type selection change
    $(document).on(this.scopedEvent('change'), this.scopedSelector('.js-size-type-selection'), (e) => {
        const newSizeType = e.target.value;

        // TODO: update query param type when size type is changed for server refresh
        setTimeout(() => {
            store.dispatch(changeSizeType(newSizeType, e, _this));
        }, 0);
    });

    // Watch for size selection change
    $(document).on(this.scopedEvent('change'), this.scopedSelector('.js-size-select'), (e) => {
        const newSize = e.target.value;
        const product = this.getTargetedProduct(store.getState());
        const backInStockEnabled = _.get(product, 'backInStockEnabled');

        this.event = e;

        // TODO: update query param size when size is changed for server refresh
        setTimeout(() => {
            store.dispatch(changeSize(newSize, e, _this));

            if (backInStockEnabled) {
                store.dispatch(backInStockView('link', e, _this));
            }
        }, 0);
    });

    // Watch for quantity selection change
    $(document).on(this.scopedEvent('change'), this.scopedSelector('.js-quantity-select'), (e) => {
        const newQuantity = parseInt(e.target.value, 10);

        setTimeout(() => {
            store.dispatch(changeQuantity(newQuantity, e, _this));
        }, 0);
    });

    $(document).on(this.scopedEvent('click'), this.scopedSelector('.js-size-chart-link'), (e) => {
        e.preventDefault();
        const payload = pushModalTransition(sizeGuideInit, {}, e, _this.name);

        store.runSaga(getSizeGuideForTypeCodeSaga).done.then(() => {
            $.event.trigger({
                type: payload.type,
                payload: payload
            });
        });
    });

    $(document).on(this.scopedEvent('click'), this.scopedSelector('.js-launch-quickship-info'), (e) => {
        e.preventDefault();
        const payload = pushModalTransition(quickshipInfoModalInit, this.getInheritedOverrides(), e, this.name);

        $.event.trigger({
            type: payload.type,
            payload: payload
        });
    });
}

function afterConstruction(store) {
    const _this = this;
    const product = this.getTargetedProduct(this.getState());

    if (!product || _.isEmpty(product)) {
        return;
    }

    if (!product.productUnavailable && !product.isSoldOut) {
        $(document).ready(() => {
            _this.attachValidation(store);
        });
    }
}

function activateFieldValidation(store) {
    const form = $(this.scopedSelector()).parents('.js-product-add-form');

    form.parsley().on('field:validated', (e) => {
        const [values, messages, dateFormats] = checkForm(`#${form.attr('id')}`);

        setTimeout(() => {
            store.dispatch(saveFormValidation(values, messages, dateFormats, this));
        }, 0);
    });
}

/**
 * Bind parsley to the form
 * @param {object} store The store
 */
function attachValidation(store) {
    const domForm = $(this.scopedSelector()).parents('.js-product-add-form');

    if (domForm.length && shouldActivateParsley(domForm)) {
        this.activateFieldValidation(store);

        domForm.parsley().on('form:validate', (e) => {
            // Turn off the individual field validations when validating the form to
            // prevent a bazillion form validation messages from firing.
            domForm.parsley().off('field:validated');

            // fixes ios issue with not scrolling to first invalid field
            if (isIosDevice() && !e.isValid()) {
                _.forEach(e.fields, (field) => {
                    if (field.validationResult !== true) {
                        scrollToElement(field.$element[0]);
                    }
                    return false;
                });
            }
        });

        domForm.parsley().on('form:validated', (e) => {
            const [values, messages, dateFormats] = checkForm(`#${domForm.attr('id')}`);

            store.dispatch(saveFormValidation(values, messages, dateFormats, this));
            this.activateFieldValidation(store);
        });
    }
}

function afterRender(store) {
    if ($(this.event.target).hasClass('js-size-select') && (/Safari/i).test(navigator.userAgent)) {
        forcePageReflow(this.scopedSelector('.js-size-select'));
    }

    this.event = {};
}

function afterRebind(store) {
    const product = this.getTargetedProduct(store.getState());

    if (!product.productUnavailable && !product.isSoldOut) {
        this.attachValidation(store);
    }
}

export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-pdp .dom-main-product .dom-product-controls',
        activateFieldValidation: activateFieldValidation,
        attachEvents: attachEvents,
        attachValidation: attachValidation,
        afterConstruction: afterConstruction,
        template: template,
        watch: [
            'product.productControls',
            'product.reviews.averageFitRating'
        ],
        name: 'productControlsComponent',
        forFamilyProduct: false,
        replace: 'once',
        onStateChange: onStateChange,
        afterRebind: afterRebind,
        afterRender: afterRender,
        renderType: mDom,
        renderOptions: {
            onBeforeElChildrenUpdated: (fromEl, toEl) => {
                if ($(fromEl).hasClass('dom-product-gift-card')) {
                    return false;
                } else if ($(fromEl).hasClass('js-size-select')) {
                    $(fromEl).val($(toEl).val());
                } else if ($(fromEl).hasClass('js-gift-message-textarea')) {
                    $(toEl).val($(fromEl).val());
                }

                return true;
            }
        },
        event: {}
    };

    overrides.getState = store.getState;
    return generate(config, store, overrides);
}
